// ─── Une FONCTION dans l'écran Forfaits ───────────────────────────
// Deux réglages sur la même ligne, qui répondent à deux questions différentes :
//   • la bascule = coupe-circuit global (personne n'y a droit, quel que soit le
//     forfait) ;
//   • les puces = à partir de QUEL palier la fonction est incluse.
// Une sous-fonction dépend de son parent : on la décale et on l'estompe quand
// le parent est coupé.
import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ChoixPuces, Bascule, Stepper, PALIERS, poidsDe, useUI, useT } from '@mop/core';

const OPTIONS = PALIERS.map(p => ({ id: p.id, label: p.label }));

export default function LigneFonctionForfait({ def, cfg, sous = false, coupeParent = false, onGlobale, onPalier, onPoids }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const active = cfg.globales?.[def.key] !== false;
  const palier = cfg.paliers?.[def.key] || def.palier || 'basic';
  const poids = poidsDe(cfg, def);

  return (
    <View style={[s.fonc, sous && s.foncSous, coupeParent && s.eteint]}>
      <View style={s.tete}>
        <Text style={{ fontSize: sous ? 13 : 15 }}>{def.icone || '🔹'}</Text>
        <View style={{ flex: 1 }}>
          <Text style={[s.nom, sous && s.nomSous]} numberOfLines={1}>{def.label || def.key}</Text>
          {!!def.desc && <Text style={s.desc} numberOfLines={1}>{def.desc}</Text>}
        </View>
        {/* Achetable hors forfait : l'admin doit le voir avant de fixer le palier. */}
        {!!def.individuel && <Text style={s.carte}>🛒</Text>}
        <Bascule valeur={active} accessibilityLabel={def.label || def.key}
          onChange={(v) => onGlobale?.(def.key, v)} />
      </View>
      <ChoixPuces value={palier} options={OPTIONS} onChange={(v) => onPalier?.(def.key, v)} />
      {/* Poids dans le pool à la carte — seulement pour les fonctions ACHETABLES,
          les autres ne rentrent jamais dans le panier de points. */}
      {!!def.individuel && (
        <View style={s.poidsRow}>
          <Text style={s.poidsLbl}>🛒 {t('admin.poidsFonction')}</Text>
          <Stepper valeur={poids} onMoins={() => onPoids?.(def.key, poids - 1)} onPlus={() => onPoids?.(def.key, poids + 1)} />
        </View>
      )}
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  fonc: { paddingVertical: 9, borderTopWidth: 0.5, borderTopColor: UI.border, gap: 7 },
  foncSous: { paddingLeft: 16 },
  eteint: { opacity: 0.45 },
  tete: { flexDirection: 'row', alignItems: 'center', gap: 9 },
  nom: { fontSize: 13.5, fontWeight: '700', color: UI.ink },
  nomSous: { fontSize: 12.5, fontWeight: '600' },
  desc: { fontSize: 11, color: UI.faint, marginTop: 1 },
  carte: { fontSize: 12, color: UI.muted },
  poidsRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  poidsLbl: { fontSize: 12, fontWeight: '700', color: UI.ink },
});
